import { initLayout } from '../layout.js';

// Home content is prerendered at build time for SEO; JS only initializes layout/theme.
initLayout();
